import * as z from "zod/v4";

export const toggleCallOnHold = {
  name: "toggleCallOnHold" as const,
  input: z.object({ customerCallId: z.string(), onHold: z.boolean() }),
  output: z.object({}),
};
